<template>
    <div class="aside_2">
        <div class="currentStatus">
            <h4>当前状态</h4>
            <div class="currentWrap">
                <div class="imgWrap">
                    <img src="../../../assets/images/mine/vip.png" alt="">
                </div>
                <div v-if="memberExpireTime!=null" class="currentWrap_right">
                    <h3>超级VIP会员</h3>
                    <p>到期时间: <span v-if="memberExpireTime!=null">{{memberExpireTime|formatDate}}</span></p>
                </div>
                <div v-if="!memberExpireTime" class="currentWrap_right">
                    <h3>普通用户</h3>
                </div>
            </div>
            <div class="wayType">
                <div class="wayItem" :class="index == payType.num ? 'active' : ''" v-for="(item,index) in payType.tabs" :key="index" @click="tabCard(index, item.id)">
                    <h4>{{ item.typeName }}<span v-if="item.introduction" :title="item.introduction">{{item.introduction}}</span>
                    </h4>
                    <p>
                        <span class="spanActive" v-if="item.money">￥{{ item.money }}</span>
                        <span>{{item.monthNum}}个月</span>
                    </p>
                    <img src="../../../assets/images/mine/recomond.png" alt="">
                    <span class="postionSpan">推荐</span>
                </div>
            </div>
        </div>
        <div class="payWay">
            <h4>支付方式</h4>
            <div class="payWayWrap">
                <div class="payItem_left">
                    <div class="codeWrap">
                        <el-popover
                            placement="left"
                            width="160"
                            trigger="manual"
                            v-model="showCode">
                            <p>微信扫码付款</p>
                            <canvas class="code" ref="wechatQRcode">
                            </canvas>
                            <div style="text-align: right; margin: 0">
                                <el-button  type="danger" size="mini" plain @click="closeQRcode">关闭</el-button>
                            </div>
                            <img class="pay-img" slot="reference" src="@/assets/images/wechatPay.png" alt="微信支付" @click="getQRcode">
                        </el-popover>
                        <h3>微信支付</h3>
                        <p>点击获取微信二维码</p>
                    </div>
                    <div class="codeWrap">
                        <img class="pay-img" src="@/assets/images/alipay.png" alt="支付宝支付" @click="jumpToAlipay">
                        <h3>支付宝支付</h3>
                        <p>点击去支付宝支付</p>
                    </div>
                </div>
                <div class="payItem_right">
                    <h4>支付<i v-if="showMoney">￥{{ payType.tabs[payType.num].money }}元</i></h4>
                    <p>支付后自动刷新页面，即可享受超级会员</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
  import {formatDate} from '../../../utils/date.js';
  import { getToken, setToken, setUser,getUser } from '../../../utils/auth.js';
  import QRCode from 'qrcode'
    export default {
        data() {
            return {
                times: 0,
                wechatTimer: null,
                showCode: false,
                memberTypeId: null,
                payType: {
                    tabs: [],
                    num: 0
                },
                memberExpireTime:null,
                showMoney:false
            }
        },
        filters:{
            formatDate(time){
                let date = new Date(time);
                return formatDate(date,'yyyy-MM-dd hh:mm:ss');
            }
        },
        methods:{
            
            tabCard(index, id) {
                this.payType.num = index;
                this.memberTypeId = id
            },

            // 获取微信二维码
            getQRcode(){
                clearInterval(this.wechatTimer)
                this.times = 0
                var params = {
                    token: getToken()
                };
                var data = {
                   memberTypeId: this.memberTypeId
                };
                axios({
                    method: 'get',
                    url: '/realNet/pay/vxPayUrl',
                    headers: params,
                    params:data
                }).then((res) =>{                 
                    let payUrl = res.data.result;
                    QRCode.toCanvas(this.$refs.wechatQRcode, payUrl, error => {
                        console.log(error)
                    })
                    this.showCode = true
                    this.wechatTimer = setInterval(() => {
                        this.checkPayStatus(res.data.timestamp)
                    }, 3000)
                }).catch(function (error) {
                    console.log(error);
                })
            },
            closeQRcode() {
                this.showCode = false
                clearInterval(this.wechatTimer)
                this.times = 0
            },

            // 打开支付宝链接
            jumpToAlipay() {
                clearInterval(this.wechatTimer)
                this.times = 0
                var params = {
                    token: getToken()
                }
                var data = {
                   memberTypeId: this.memberTypeId
                }
                let newWindow = window.open(window.location.href)
                axios({
                    method: 'get',
                    url: '/realNet/alipay/pay',
                    headers: params,
                    params:data
                })
                .then((res) =>{
                    setTimeout(() => {
                        newWindow.document.write(res.data)
                    }, 500)
                    this.wechatTimer = setInterval(() => {
                        this.checkPayStatus(new Date().getTime())
                    }, 3000)
                })
                .catch(function (error) {
                    console.log(error);
                })
            },
            //获取会员类型
            vipFn(){
               let params = {
                    token: getToken()
                };
                axios({
                    method: 'get',
                    url: '/realNet/memberType/getMemberTypes',
                    headers: params
                })
                .then((res) =>{
                    this.payType.tabs = res.data.result.content
                    this.memberTypeId = this.payType.tabs[0].id
                    this.showMoney = true;
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            // 查询支付状态
            checkPayStatus(timestamp) {
                this.times++
                // 超过3分钟仍未支付
                if (this.times > 60) {
                    this.$notify.warning({
                        title: '支付超时',
                        message: '请重新进行支付'
                    })
                    this.showCode = false
                    clearInterval(this.wechatTimer)
                    return false
                }
                let params = {
                    beginTime: timestamp,
                    orderByType: 'DESC'
                }
                axios({
                    url: '/realNet/order/getOrders',
                    headers: {
                        token: getToken()
                    },
                    params: params,
                    method: 'GET'
                }).then(res => {
                    for (let i of res.data.result.content) {
                        if (i.status === 1) {
                            this.$notify({
                                title: '支付成功',
                                message: '即将跳转至订单管理页面',
                                type: 'success',
                                duration: 3000,
                                onClose: () => {
                                    this.$emit('jumpToOrder')
                                }
                            })
                        } else if (i.status === 2) {
                            this.$notify({
                                title: '支付失败',
                                message: '即将跳转至订单管理页面',
                                type: 'warning',
                                duration: 3000,
                                onClose: () => {
                                    this.$emit('jumpToOrder')
                                }
                            })
                        }
                    }
                })
            }
        },
        mounted() {
            var user = JSON.parse(getUser());
            this.memberExpireTime = user.memberExpireTime;
            this.vipFn();
        },
        beforeDestroy() {
            clearInterval(this.wechatTimer)
            this.times = 0
        }
    }
</script>

<style lang='scss' scoped>
    .aside_2 {
        width: 930px;
    }
    .currentStatus {
        width: 100%;

        h4 {
            font-size: 14px;   
            font-weight: bold;
            
            margin-bottom: 15px;
        }
        .currentWrap {
            width: 100%;
            height: 90px;
            padding: 26px 20px;

            background: url('../../../assets/images/mine/line_bg.png') no-repeat;
            background-size: 100% 100%;
            box-sizing: border-box;

            display: flex;
            align-items: center;

            .imgWrap {
                width: 50px;
                height: 37px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .currentWrap_right {
                width: 40%;
                height: 45px;
                margin-left: 20px;

                h3 {
                    margin-bottom: 10px;

                    color: #F1D08F;
                    font-size: 16px;
                }
                p {
                    font-size: 14px;
                    color: rgba(#fff,.8);
                }
            }
        }
        .wayType {
            width: 100%;
            height: 100px;
            margin: 30px 0 50px;
            display: flex;

            .wayItem {
                width: 218px;
                height: 100px;
                padding: 15px 10px;
                margin-right: 20px;
                border: 1px solid #3BC0D0;
                background-color: #F3F7F8;
                box-sizing: border-box;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                position: relative;

                h4 {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 20px;
                    color: #000;
                    span {
                        display: inline-block;
                        padding: 0px 5px;
                        width: 110px;
                        height: 22px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        border: 1px solid #FF771D;
                        color: #FF771D;
                        font-size: 13px;
                        border-radius: 5px;
                        line-height: 22px;

                    }
                }
                p {
                    font-size: 14px;
                    color: #000;

                    .spanActive {
                        font-size: 20px;
                        color: #FF3600;
                        margin-right: 5px;
                    }
                }
                &.active {
                    background-color: #FFF6F3;
                    border: 2px solid #FF6E40;
                }
                & > img {
                    display: none;
                }
                &:nth-of-type(1) > img {
                    position: absolute;
                    left: -7px;
                    top: -14px;
                    display: block;
                }
                .postionSpan {
                    font-size: 14px;
                    color: #fff;
                    display: none;
                }
                &:nth-of-type(1) .postionSpan {
                    display: inline-block;
                    position: absolute;
                    left: 0px;
                    top: -12px;
                }
                &:last-child {
                    margin-right: 0px;
                }
            }
        }
    }
    .payWay {
        width: 100%;

        h4 {
            font-size: 14px;
            margin-bottom: 15px;
            font-weight: bold;
        }
        .payWayWrap {
            width: 100%;
            height: 245px;
            border: 1px solid #EAECED;

            background-color: #F9F9F9;
            display: flex;
            align-items: center;

            .payItem_left {
                width: 40%;
                height: 100%;
                margin-right: 80px;

                display: flex;
                justify-content: space-around;

                .codeWrap {
                    width: 150px;
                    height: 100%;
                    padding: 32px 0;

                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    align-items: center;

                    h3 {
                        font-size: 16px;
                    }
                    p {
                        font-size: 14px;
                        color: #888888;
                    }
                    .pay-img {
                        width: 112px;
                        height: 112px;
                        border: 1px solid #e3e3e3;
                        cursor: pointer;
                    }
                }
            }
            .payItem_right {
                font-size: 16px;
                color: #666666;

                h4 {
                    font-size: 20px;

                    i {
                        color:#FF4314;
                        font-size: 30px;
                    }
                }
            }
        }
    }
    .code {
        width: 100% !important;
        height: 100% !important;
    }
</style>